import React from 'react'
import * as styles from './order.module.css'
import { useState } from 'react'
import Modal from '../UI/modal'

const Order = () => {
  const [showModal, setShowModal] = useState(false)
  const modalHandler = () => {
    setShowModal((prev) => setShowModal(!prev))
  }
  return (
    <section>
      <div className={styles.order}>
        <span>Отправьте нам запрос</span>
        <h2>Нужен новый веб-сайт?</h2>
        <span>
          Оставьте Ваши контакты и мы свяжемся с Вами в кратчайшее время,
          уточним детали и начнем создание сайта!
        </span>
        <button onClick={modalHandler}>Заказать веб-сайт</button>
      </div>
      <Modal onClose={modalHandler} show={showModal} />
    </section>
  )
}

export default Order
